/* eslint-disable react/prop-types */
import { Typography } from '@styles';
import React from 'react';

import { Chars } from './TypingTextAnimation.layoutProps';

export const renderLineWrapper =
  (textProps, activeAnimation, dynamicWidth) =>
  ({ children, lineIndex }) => (
    <Chars
      display="inline-flex"
      dynamicWidth={dynamicWidth}
      gap={5}
      isActive={lineIndex === activeAnimation}
      isVisible={lineIndex <= activeAnimation}
      variant="MS-regular-s18-lh22"
      {...(textProps && textProps)}
    >
      {children}
    </Chars>
  );

export const renderWordWrapper =
  (boldWordsIndexes) =>
  ({ children, countIndex }) => (
    <Typography
      variant={`MS-${boldWordsIndexes.includes(countIndex) ? 'bold' : 'regular'}-s18-lh22`}
    >
      {children}
    </Typography>
  );
